import React from 'react';
import { resolveValue } from 'react-hot-toast';

/* Стеклянная плашка лога (дизайн 1c): цветная иконка в рамке, заголовок,
   подпись, время справа и полоска-таймер по нижней кромке.

   Подключается через render-prop у <Toaster>, поэтому все существующие вызовы
   toast.success / toast.error / toast.loading продолжают работать как были.
   Подзаголовок можно передать вторую строкой: toast.success('Сохранено\nЧерновик обновлён'). */

const IcOk = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
);
const IcErr = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
);
const IcInfo = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
);

const pad = (n) => String(n).padStart(2, '0');

export default function ToastCard({ t }) {
  const kind = t.type === 'success' ? 'ok'
    : t.type === 'error' ? 'err'
      : t.type === 'loading' ? 'load' : 'info';

  const raw = resolveValue(t.message, t);
  const [title, ...rest] = String(raw ?? '').split('\n');
  const sub = rest.join(' ').trim();

  const d = new Date(t.createdAt || Date.now());
  const time = `${pad(d.getHours())}:${pad(d.getMinutes())}`;

  return (
    <div className={`lg-toast ${kind}${t.visible ? ' in' : ' out'}`}>
      <span className="lg-toast-ic">
        {kind === 'ok' ? <IcOk />
          : kind === 'err' ? <IcErr />
            : kind === 'load' ? <span className="lg-toast-spin" />
              : <IcInfo />}
      </span>
      <div className="lg-toast-main">
        <div className="lg-toast-title">{title}</div>
        {sub && <div className="lg-toast-sub">{sub}</div>}
      </div>
      <span className="lg-toast-time">{time}</span>
    </div>
  );
}
